module.exports = __webpack_public_path__ + "static/img/banner_desktop1.0388fda5.jpg";